<template>
  <v-col :cols="cols">
    <v-card class="mx-1 mt-1 mb-1">
      <v-card-title class="pa-6 pb-0 pt-0">
        <v-spacer></v-spacer>
      </v-card-title>
      <v-card-text class="pa-6 pt-0">
        <v-row class="mb-12 mt-11" no-gutters fill-height>
          <v-col cols="6" class="my-auto">
            <div
              class=""
              :style="{ 'font-size': text_font_size, 'font-weight': 'bold' }"
              >{{ title_number }}
            </div>
            <div>
              {{ subTitle }}
            </div>
          </v-col>
          <v-spacer></v-spacer>
          <v-col>
            <v-btn x-large :loading="isLoading" elevation="2" color="primary" @click="onButtonClick">
              {{ $t(buttonMsg) }}
            </v-btn>
          </v-col>
        </v-row>
      </v-card-text>
    </v-card>
  </v-col>
</template>

<script lang="ts">
import Vue from "vue";
import { Component, Prop } from "vue-property-decorator";

@Component
export default class DeviceOverviewButtonCard extends Vue {
  @Prop() readonly title_number: string;
  @Prop() readonly subTitle: string;
  @Prop() readonly text_font_size: string;
  @Prop({default: 4}) cols: number; 
  @Prop({default: 'RESET'}) buttonMsg: string; 
  @Prop({default: 2}) loaderSecs: number; 

  buttonLoading = false;
  
  get isLoading() {
    return this.buttonLoading
  }

  onButtonClick() {
    this.buttonLoading = true;
    setTimeout(() => this.buttonLoading = false, this.loaderSecs * 1000) 

    this.$emit("buttonPressed");
  }
}
</script>

<style lang="scss">
@import "../../styles/app";

.dashboard-page {
  .page-title {
    padding-bottom: 20px;
    @include media-breakpoint-up(sm) {
      padding-bottom: 0;
    }
  }
  .apexcharts-legend-series {
    padding: 2px 5px 3px;
    display: flex;
    align-items: center;
    .apexcharts-legend-marker {
      margin-right: 8px;
    }
  }
  .main-chart-select {
    font-size: 1rem;
    margin-right: 10px;
    fieldset {
      border-width: 1px !important;
      border-color: $text-grey !important;
      color: $text-grey !important;
    }
    .v-select__selection {
      color: $text-color !important;
    }
  }
  .v-card {
    .v-card__text {
      .subtext {
        font-size: 1.142rem;
        font-weight: 400;
        color: $title-grey;
      }
      .subtext-index {
        font-size: 11px;
        color: $text-color;
        font-weight: 400;
      }
    }
  }
}

.v-menu__content {
  box-shadow: $card-shadow !important;
  .v-list-item__content .v-list-item__title {
    font-size: 1rem;
    font-weight: 400;
  }
}
.button-shadow {
  box-shadow: $button-shadow;
}
</style>
